export const TOKEN_VARIABLE_NAME = 'token';
export const MALE = 'M';
export const FEMALE = 'F';
